import React from 'react';
import Survey, { CssNames } from '../../../Survey';
import DemographicsSurvey, { TestIntro } from './demographics';
import DemographicsWrapper from './demographics.styles';

class Recursos extends React.Component {
  state = {
    intro: true
  };
  onCompleteIntro = () => {
    this.setState({ intro: false });
  };

  onComplete = async (survey, options) => {
    const { onComplete } = this.props;

    const { data } = survey;
    const parsed = {
      ...data
    };
    await onComplete(parsed);
  };

  render() {
    const { intro } = this.state;
    const IntroModel = new Survey.Model(TestIntro);
    const DemographicsModel = new Survey.Model(DemographicsSurvey);
    // setting starting data
    DemographicsModel.data = this.props.initialData || {};

    return (
      <DemographicsWrapper>
        <div className='edu_header'></div>
        {intro && (
          <Survey.Survey
            model={IntroModel}
            css={CssNames}
            onComplete={this.onCompleteIntro}
          />
        )}
        {!intro && (
          <Survey.Survey
            model={DemographicsModel}
            css={CssNames}
            onComplete={this.onComplete}
          />
        )}
        <div className='Plug'>
          <a
            href='http://www.edumetrics.cl/'
            target='_blank'
            rel='noopener noreferrer'
          >
            EduMetrics
          </a>
        </div>
      </DemographicsWrapper>
    );
  }
}

export default Recursos;
